import { buildZip } from '../../lib/zip'
import { trackDownloadAll } from '../../analytics/posthog'
import { useT } from '../../i18n/useT'

interface DownloadAllButtonProps {
  getFiles: () => { name: string; content: string }[]
  zipName: string
}

/** Appears (with a fade-in) once every format has been collected from the server. */
export function DownloadAllButton({ getFiles, zipName }: DownloadAllButtonProps) {
  const t = useT()
  function handleDownload() {
    const blob = buildZip(getFiles())
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = zipName
    a.click()
    URL.revokeObjectURL(url)
    trackDownloadAll()
  }

  return (
    <button
      onClick={handleDownload}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm whitespace-nowrap text-text-secondary hover:text-text rounded-lg hover:bg-surface-hover transition-colors animate-in fade-in duration-500"
      title={t('result.downloadAllTitle')}
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
      {t('result.downloadAll')}
    </button>
  )
}
